import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type UpdateStatus =
  | "up_to_date"
  | "behind"
  | "pending"
  | "deferred"
  | "failed"
  | "unknown";

const LABELS: Record<UpdateStatus, string> = {
  up_to_date: "Up to date",
  behind: "Behind",
  pending: "Pending",
  deferred: "Deferred",
  failed: "Failed",
  unknown: "Unknown",
};

const STYLES: Record<UpdateStatus, string> = {
  up_to_date: "bg-success-muted text-success border-success/20",
  behind: "bg-destructive/10 text-destructive border-destructive/20",
  pending: "bg-info-muted text-info border-info/20",
  deferred: "bg-muted text-muted-foreground border-border",
  failed: "bg-destructive/10 text-destructive border-destructive/20",
  unknown: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ status }: { status: UpdateStatus }) {
  return (
    <Badge variant="outline" className={cn("font-medium", STYLES[status])}>
      {LABELS[status]}
    </Badge>
  );
}

export default StatusBadge;
